// vue
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import State from 'ol/source/State';

Vue.use(Vuex);

let protocol,
    wsProtocol,
    wsSubdomain,
    wsDomain,
    url,
    apiPort,
    apiSubdomain,
    geoserverUrl,
    geoserverPort,
    geoserverSubdomain,
    ctsProtocol,
    clereTileserverSubdomain,
    clereTileserverDomain,
    clereTileserverPort,
    MosaicsSubdomain,
    MosaicsProtocol,
    MosaicsDomain,
    MosaicsPort,
    puttProtocol,
    puttSubdomain,
    puttDomain,
    puttPort,
    whsProtocol,
    whsSubdomain,
    whsDomain,
    whsPort,
    bunnyNetBaseUrl,
    puttUrl,
    whsUrl,
    websocketUrl;

protocol = '__CG_API_PROTOCOL__'; //'https://';
apiSubdomain = '__CG_API_SUBDOMAIN__'; //'api.dev.';
url = '__CG_API_DOMAIN__'; //'cleregolfhub.com';
apiPort = '__CG_API_PORT__'; //'';
wsProtocol = '__CG_WS_PROTOCOL__'; //'wss://';
wsSubdomain = '__CG_WS_SUBDOMAIN__'; //'simulator.',
wsDomain = '__CG_WS_DOMAIN__'; //'cleregolfhub.com',
geoserverSubdomain = '__CG_GEOSERVER_SUBDOMAIN__'; //'geo.dev.';
geoserverUrl = '__CG_GEOSERVER_URL__'; //'cleregolfhub.com';
geoserverPort = '__CG_GEOSERVER_PORT__'; //'';
ctsProtocol = '__CG_CTS_PROTOCOL__'; //'https://';
clereTileserverSubdomain = '__CG_CTS_SUBDOMAIN__'; //'cts.dev.';
clereTileserverDomain = '__CG_CTS_DOMAIN__'; //'cleregolfhub.com';
clereTileserverPort = '__CG_CTS_PORT__'; //'';
MosaicsSubdomain = '__CG_MAPTILER_SUBDOMAIN__'; //'cts.dev.';
MosaicsProtocol = '__CG_MAPTILER_PROTOCOL__'; //'https://';
MosaicsDomain = '__CG_MAPTILER_DOMAIN__'; //'cleregolfhub.com';
MosaicsPort = '__CG_MAPTILER_PORT__'; //'';
puttProtocol = '__CG_PUTT_PROTOCOL__'; //'https://';
puttSubdomain = '__CG_PUTT_SUBDOMAIN__'; //'putt.';
puttDomain = '__CG_PUTT_DOMAIN__'; //'cleregolfhub.com';
puttPort = '__CG_PUTT_PORT__';
whsProtocol = '__CG_WHS_PROTOCOL__'; //"https://",
whsSubdomain = '__CG_WHS_SUBDOMAIN__'; //'whs.',
whsDomain = '__CG_WHS_DOMAIN__'; //'cleregolfhub.com';
whsPort = '__CG_WHS_PORT__';

//check and replace if not replaced already
const replacePlaceholder = (varname: any, envvalue: string) => {
    // if first two and last two letters are underscores placeholder is still in place
    if (varname === undefined) {
        varname = envvalue;
    } else if (varname.slice(0, 2) == '__' && varname.slice(-2) == '__') {
        varname = envvalue;
    }
    return varname;
};

const replaceEnvironmentVariables = () => {
    protocol = replacePlaceholder(
        protocol,
        process.env.VUE_APP_CG_API_PROTOCOL,
    );
    wsProtocol = replacePlaceholder(
        wsProtocol,
        process.env.VUE_APP_CG_WS_PROTOCOL,
    );
    wsSubdomain = replacePlaceholder(
        wsSubdomain,
        process.env.VUE_APP_CG_WS_SUBDOMAIN,
    );
    wsDomain = replacePlaceholder(wsDomain, process.env.VUE_APP_CG_WS_DOMAIN);
    url = replacePlaceholder(url, process.env.VUE_APP_CG_API_DOMAIN);
    apiPort = replacePlaceholder(apiPort, process.env.VUE_APP_CG_API_PORT);
    console.log('Initial Check', url);
    apiSubdomain = replacePlaceholder(
        apiSubdomain,
        process.env.VUE_APP_CG_API_SUBDOMAIN,
    );
    geoserverUrl = replacePlaceholder(
        geoserverUrl,
        process.env.VUE_APP_CG_GEOSERVER_DOMAIN,
    );
    geoserverPort = replacePlaceholder(
        geoserverPort,
        process.env.VUE_APP_CG_GEOSERVER_PORT,
    );
    geoserverSubdomain = replacePlaceholder(
        geoserverSubdomain,
        process.env.VUE_APP_CG_GEOSERVER_SUBDOMAIN,
    );
    ctsProtocol = replacePlaceholder(
        ctsProtocol,
        process.env.VUE_APP_CG_CTS_PROTOCOL,
    );
    clereTileserverSubdomain = replacePlaceholder(
        clereTileserverSubdomain,
        process.env.VUE_APP_CG_CTS_SUBDOMAIN,
    );

    clereTileserverDomain = replacePlaceholder(
        clereTileserverDomain,
        process.env.VUE_APP_CG_CTS_DOMAIN,
    );

    clereTileserverPort = replacePlaceholder(
        clereTileserverPort,
        process.env.VUE_APP_CG_CTS_PORT,
    );

    MosaicsProtocol = replacePlaceholder(
        MosaicsProtocol,
        process.env.VUE_APP_CG_MAPTILER_PROTOCOL,
    );
    MosaicsSubdomain = replacePlaceholder(
        MosaicsSubdomain,
        process.env.VUE_APP_CG_MAPTILER_SUBDOMAIN,
    );
    MosaicsDomain = replacePlaceholder(
        MosaicsDomain,
        process.env.VUE_APP_CG_MAPTILER_DOMAIN,
    );
    MosaicsPort = replacePlaceholder(
        MosaicsPort,
        process.env.VUE_APP_CG_MAPTILER_PORT,
    );

    puttProtocol = replacePlaceholder(
        puttProtocol,
        process.env.VUE_APP_CG_PUTT_PROTOCOL,
    );
    puttSubdomain = replacePlaceholder(
        puttSubdomain,
        process.env.VUE_APP_CG_PUTT_SUBDOMAIN,
    );
    puttDomain = replacePlaceholder(
        puttDomain,
        process.env.VUE_APP_CG_PUTT_DOMAIN,
    );
    puttPort = replacePlaceholder(puttPort, process.env.VUE_APP_CG_PUTT_PORT);
    whsProtocol = replacePlaceholder(
        whsProtocol,
        process.env.VUE_APP_CG_WHS_PROTOCOL,
    );
    whsSubdomain = replacePlaceholder(
        whsSubdomain,
        process.env.VUE_APP_CG_WHS_SUBDOMAIN,
    );
    whsDomain = replacePlaceholder(
        whsDomain,
        process.env.VUE_APP_CG_WHS_DOMAIN,
    );
    whsPort = replacePlaceholder(whsPort, process.env.VUE_APP_CG_WHS_PORT);
};
replaceEnvironmentVariables();
/**
 * apiInstance determines whether the hub will connect to a localhub or remote
 * instance of the API.
 *
 * Available options:
 *     - 'localhub'
 *     - 'remote'
 */

const store = {
    state: {
        versionString: '1.9.402-alpha',
        date: '2025',
        apiUrl: protocol + apiSubdomain + url + apiPort,
        frontendBaseURL: window.location.origin,
        bunnyNetBaseUrl: 'https://clere-golf.b-cdn.net',
        clereTileserverUrl:
            ctsProtocol +
            clereTileserverSubdomain +
            clereTileserverDomain +
            clereTileserverPort,
        apiWsUrl: wsProtocol + apiSubdomain + url + apiPort,
        MaptilerUrl:
            MosaicsProtocol + MosaicsSubdomain + MosaicsDomain + MosaicsPort,
        puttUrl: puttProtocol + puttSubdomain + puttDomain + puttPort,
        whsUrl: whsProtocol + whsSubdomain + whsDomain + whsPort,
        websocketUrl: wsProtocol + wsSubdomain + wsDomain,
        // notificationSocket: new WebSocket('wss://' + url + apiPort + '/notification/websocket'),
        geoserverWmts:
            'https://' +
            geoserverSubdomain +
            geoserverUrl +
            geoserverPort +
            '/geoserver/gwc/service/wmts',
        geoserverWfs:
            'https://' +
            geoserverSubdomain +
            geoserverUrl +
            geoserverPort +
            '/geoserver/wfs',

        authToken: localStorage.getItem('authToken'),
        tempAuthToken: localStorage.getItem('tempAuthToken'),
        multiUserAuthToken: localStorage.getItem('multiUserAuthToken'),
        accountPermissions: localStorage.getItem('accountPermissions'),
        masqueradeAccountPermissions: localStorage.getItem(
            'masqueradeAccountPermissions',
        ),

        currentOrganization: localStorage.getItem('currentOrganization'),
        courseSchemas: localStorage.getItem('courseSchemas'),
        currentCourseSchema: localStorage.getItem('currentCourseSchema'),
        airtableApiKey: localStorage.getItem('airtableApiKey'),
        airtableBaseKey: localStorage.getItem('airtableBaseKey'),
        airtableTableName: localStorage.getItem('airtableTableName'),
        account: localStorage.getItem('account'),
        bus: new Vue(),
        cancelToken: axios.CancelToken.source(),
        isMobile: false,
        alwaysAllowedRoutes: ['/privacy-policy', '/tos'],
        allowedRoutes: [
            '/login',
            '/forgotten-password',
            '/reset-password',
            '/privacy-policy',
            '/tos',
        ],
        fullScreenRoutes: [
            'ground2control',
            'sketchfab',
            'feature-analysis',
            'feature-analysis2',
            'feature-analysis3',
            'irrigation-analysis',
            'full-screen-example',
            'geo-record-view',
            'agrio',
            'core',
            'people',
            'kit',
            'money',
            'safety-assessments',
            'safety-procedures',
            'safety-tools',
            'safety-reference',
            '3d-model',
            'flythrough',
            'babylon',
            'course-model',
            'tournament-ball-position',
            'course-manager',
            'putt',
            'CourseOverview',
            'public-course-info'
        ],
        lowEndHardware:
            localStorage.getItem('lowEndHardware') === null ? false : true,
        notificationCount:
            localStorage.getItem('notificationCount') == null
                ? 0
                : parseInt(localStorage.getItem('notificationCount') || '0'),
        isMeters: localStorage.getItem('isMeters') === null ? false : true,
        mapboxToken:
            'pk.eyJ1IjoiY2xlcmVnb2xmIiwiYSI6ImNsMDA0bXF3ZTA4enEzaW1lbm82bTg1NDUifQ.SUL023sSnXEUXAiUgQ8iGA',
        isNavigationDrawerOpen: false,
        isKeyLineView: false,
        isFullScreen: false,
        isMaintenanceMode: false,
        isGPSCreateModeOn: false,
        currentWeatherData: localStorage.getItem('currentWeatherData')
    },
    getters: {
        currentCourseSchema: (state) => {
            if (state.currentCourseSchema) {
                return JSON.parse(state.currentCourseSchema);
            }
        },
        currentOrganization: (state) => {
            if (state.currentOrganization) {
                return JSON.parse(state.currentOrganization);
            }
        },
        isFullScreen: (state) => {
            return state.isFullScreen;
        },
        isAuthenticated: (state) => {
            return !!state.account;
        },
        account: (state) => {
            if (state.account) {
                return JSON.parse(state.account);
            }
        },
        isKeyLineView: (state) => {
            return state.isKeyLineView;
        },
        getCurrentWeatherData: (state) => {
            const weatherData = JSON.parse(state.currentWeatherData) || {};
            const currentCourseSchemaID = JSON.parse(state.currentCourseSchema).id;
            return weatherData[currentCourseSchemaID]
        },
        /**
         * Calculates if the drawer is closable based on if the view is mobile
         * or the route is a fullscreen route.
         */
        isNavigationDrawerClosable: (state) => {
            return store.getters.isFullScreen(state) || state.isMobile;
        },
        isMobile: (state) => {
            return state.isMobile;
        },
    },
    mutations: {
        setNotificationCount(state, val) {
            if (val && val > 0) {
                state.notificationCount = val;
                localStorage.setItem('notificationCount', `${val}`);
            } else {
                state.notificationCount = 0;
                localStorage.setItem('notificationCount', '0');
            }
        },
        setIsMeters(state, val) {
            state.isMeters = val;
            if (val === true) localStorage.setItem('isMeters', 'true');
            else localStorage.removeItem('isMeters');
        },
        setLowEndHardware(state, val) {
            state.lowEndHardware = val;
            if (val === true) localStorage.setItem('lowEndHardware', 'true');
            else localStorage.removeItem('lowEndHardware');
        },
        setIsNavigationDrawerOpen(state, val) {
            state.isNavigationDrawerOpen = val;
        },
        setIsKeyLineView(state, val) {
            state.isKeyLineView = val;
        },
        setIsFullScreen(state, val) {
            state.isFullScreen = val;
        },
        setCurrentCourseSchema(state, val) {
            state.currentCourseSchema = JSON.stringify(val);
            localStorage.setItem('currentCourseSchema', JSON.stringify(val));
        },
        setIsMobile(state, val) {
            state.isMobile = val;
        },

        setAirtableApiKey(state, value) {
            state.airtableApiKey = value;
            if (value) {
                localStorage.setItem('airtableApiKey', value);
            } else {
                localStorage.removeItem('airtableApiKey');
            }
        },
        setAirtableBaseKey(state, value) {
            state.airtableBaseKey = value;
            if (value) {
                localStorage.setItem('airtableBaseKey', value);
            } else {
                localStorage.removeItem('airtableBaseKey');
            }
        },
        setAirtableTableName(state, value) {
            state.airtableTableName = value;
            if (value) {
                localStorage.setItem('airtableTableName', value);
            } else {
                localStorage.removeItem('airtableTableName');
            }
        },
        setIsMaintenanceMode(state, value) {
            state.isMaintenanceMode = value;
        },
        setCurrentWeatherData(state, newValue) {
            const weatherData = JSON.parse(state.currentWeatherData);
            const updatedWeatherData = {...weatherData, ...newValue}
            state.currentWeatherData = JSON.stringify(updatedWeatherData);
            localStorage.setItem('currentWeatherData', JSON.stringify(updatedWeatherData));
        }
    },
    actions: {},
    modules: {},
};

export const useStore = () => {
    return new Vuex.Store(store);
};

export const storeObject = store;

export default new Vuex.Store(store);
